<div class="page-container">
  <div class="main-body">
    <div class ="section-container">
      <h1 class = "mat-display-medium">Site Map</h1>
      <p>Find your way around our website.</p>
    </div>
    <div class ="section-container">
    <ul>
      <li *ngFor="let link of sitemapLinks">
        <ng-container *ngIf="link.children?.length; else singleLink">

          <a [routerLink]="link.path">{{ link.label }}</a>
          <ul>
            <li *ngFor="let child of link.children">
              <a [routerLink]="child.path">{{ child.label }}</a>
            </li>
          </ul>
        </ng-container>

    <ng-template #singleLink>
          <a [routerLink]="link.path">{{ link.label }}</a>
        </ng-template>
      </li>
    </ul>
  </div>
  </div>

</div>
